import {takeEvery, all} from 'redux-saga/effects';
import actions from '@shared/ducks/api/actions';
import apiActionCreator from '@shared/ducks/api/sagas/apiAction';
import watchApiCompletionActions from '@shared/ducks/api/sagas/watchApiCompletionActions';

const doApiAction = apiActionCreator();

function* watchApiActions() {
  yield takeEvery(actions.API_ACTION_STARTED, doApiAction);
}

function* sagas() {
  yield all([watchApiActions(), watchApiCompletionActions()]);
}

export default sagas;
